export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/App.worker.24bb1bb6.js");
}
